<template>
  <v-row class="ma-10 elevation-5 fill-height" justify="space-around">
    <v-card class="ma-10" width="100%" flat tile>
      <v-card-title>
        <h3 class="text-h4">Quotes</h3>
        <v-spacer></v-spacer>
      </v-card-title>

      <v-data-table
        :server-items-length="quotes.total"
        :loading="loading"
        :headers="headers"
        :items="quotes"
        :options.sync="options"
        :items-per-page="10"
      >
      </v-data-table>
    </v-card>
  </v-row>
</template>

<script>
import axios from '../../../utils/axios'
import moment from 'moment'

export default {
  name: 'QuoteIndex',

  data() {
    return {
      loading: false,
      headers: [
        {
          text: 'Customer Name',
          align: 'start',
          value: 'name'
        },
        {
          text: 'Contact No',
          align: 'start',
          value: 'mobile'
        },
        {
          text: 'Email',
          align: 'start',
          value: 'email'
        },
        {
          text: 'Business(es)',
          align: 'start',
          value: 'businesses'
        },
        {
          text: 'Sent',
          align: 'start',
          value: 'time'
        }
      ],

      quotes: [],
      options: {},
      search: ''
    }
  },
  // mounted() {
  //   this.getQuotes()
  // },
  methods: {
    getQuotes() {
      this.loading = true
      axios
        .get(
          `api/admin/quotes?page=${this.options.page}&itemsPerPage=${this.options.itemsPerPage}&search=${this.search}`
        )
        .then(res => {
          let modifiedEntries = []

          res.data.forEach(item => {
            if (!item.quote) {
              return
            }

            let businessesDetail = (item.clients || []).concat(
              item.priority_listings || [],
              item.free_listings || []
            )
            let businessesName = []
            businessesDetail.map(business =>
              businessesName.push(
                'name' in business ? business.name : business.business_name
              )
            )

            let entry = {
              name: item.quote.name,
              mobile: item.quote.mobile,
              email: item.quote.email,
              businesses: businessesName.join(', '),
              time: moment(String(item.quote.created_at)).format(
                'MMMM Do YYYY, h:mm a'
              )
            }

            modifiedEntries.push(entry)
          })

          this.quotes = modifiedEntries
        })
        .catch(error => console.error(error))
        .finally(() => {
          this.loading = false
        })
    }
  },

  watch: {
    options: {
      handler() {
        this.getQuotes()
      },
      deep: true
    },
    search: {
      handler() {
        this.getQuotes()
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped></style>
